import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { Base } from "ui/Scripts/source/framework/base";
import { TaskRepetitionType } from "ui/Scripts/source/models/enums";
import { ITaskHandler, TaskHandler } from "./taskHandler";

export interface ITaskListItem {
    id: string;
    unitCode: string;
    stateId: string;
    stateCode: string;
    stateColor: string;
    priorityCode: string;
    prioritySortOrder: number;
    taskRepetitionType: TaskRepetitionType;
    typeId: string;
    typeCode: string;
    code: string;
    name: string;
    isRead: boolean;
    isArchived: boolean;
    isReadOnly: boolean;
    locked: boolean;
    removable: boolean;
    userIsHandler: boolean;
    calendarTaskCount: number;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    handlers: ITaskHandler[];

    getModifyDate(): number;
}

export class TaskListItem implements ITaskListItem {
    id: string;
    unitCode: string;
    stateId: string;
    stateCode: string;
    stateColor: string;
    priorityCode: string;
    prioritySortOrder: number;
    taskRepetitionType: TaskRepetitionType;
    typeId: string;
    typeCode: string;
    code: string;
    name: string;
    isRead: boolean;
    isArchived: boolean;
    isReadOnly: boolean;
    locked: boolean;
    removable: boolean;
    userIsHandler: boolean;
    calendarTaskCount: number;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    handlers: TaskHandler[];

    stateStr: string;

    constructor();
    constructor(obj: ITaskListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.unitCode = obj && obj.unitCode || "";
        this.stateId = obj && obj.stateId || "";
        this.stateCode = obj && obj.stateCode || "";
        this.stateColor = obj && obj.stateColor || "";
        this.priorityCode = obj && obj.priorityCode || "";
        this.prioritySortOrder = obj && obj.prioritySortOrder || 0;
        this.taskRepetitionType = obj && obj.taskRepetitionType || TaskRepetitionType.NotRepeated;
        this.typeId = obj && obj.typeId || "";
        this.typeCode = obj && obj.typeCode || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.isRead = obj && obj.isRead || false;
        this.isArchived = obj && obj.isArchived || false;
        this.isReadOnly = obj && obj.isReadOnly || false;
        this.locked = obj && obj.locked || false;
        this.removable = obj && obj.removable || false;
        this.userIsHandler = obj && obj.userIsHandler || false;
        this.calendarTaskCount = obj && obj.calendarTaskCount || 0;
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.handlers = Base.getTypedArray(obj ? obj.handlers : null, TaskHandler);
        ModifyUser.sortModifyUsers(this.handlers);
    }

    getModifyDate(): number {
        return this.modifyUser?.date ?? 0;
    }
}